/**
 * <comparison-slider> — curseur avant/après.
 *
 * Tout le geste (souris, tactile, clavier) est délégué à l'<input type="range"> posé
 * en transparence sur les images : ce composant ne fait que recopier sa valeur dans la
 * custom property --cs-pos, que le CSS utilise pour rogner l'image « avant » et
 * positionner la poignée. Rien d'autre à gérer — pas d'écouteurs de pointeur, pas de
 * calcul de coordonnées, et l'accessibilité clavier vient gratuitement avec l'input.
 */
if (!customElements.get('comparison-slider')) {
  customElements.define(
    'comparison-slider',
    class ComparisonSlider extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('[data-comparison-range]');
        if (!this.range) return;

        this.onInput = this.onInput.bind(this);
        this.range.addEventListener('input', this.onInput);
        this.apply(this.range.value);
      }

      disconnectedCallback() {
        if (this.range) this.range.removeEventListener('input', this.onInput);
      }

      onInput(event) {
        this.apply(event.target.value);
      }

      apply(value) {
        this.style.setProperty('--cs-pos', `${value}%`);
      }
    }
  );
}
